import script from "./WebhookCreateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WebhookCreateModal.vue?vue&type=script&setup=true&lang=js"

import "./WebhookCreateModal.vue?vue&type=style&index=0&id=b0287330&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0287330"]])

export default __exports__